import React from 'react';

import { FormFieldWithLinkPreview, FormFieldWithLinkPreviewProps } from 'fr-shared/components';

const MPILinkFormField = (props: FormFieldWithLinkPreviewProps) => {
  return <FormFieldWithLinkPreview {...props} showLink name="mpi_link" label="MPI URL" />;
};

export default MPILinkFormField;
